import {
  ClientDirectoryType,
  ClientMeetUpCheckListType,
  GetSingleClientDirectoryDetailsType,
  SingleClientMeetUpCheckListType,
} from "./clientDirectoryType";

export const initialState: ClientDirectoryType = {
  fetching: false,
  clientAadharUniqueCheckFetching: false,
  clientAadharUniqueCheckMessage: null,
  clientAadharUniqueCheckError: null,
  clientAadharUniqueCheckSuccess: null,
  clientPanUniqueCheckFetching: false,
  clientPanUniqueCheckMessage: null,
  clientPanUniqueCheckError: null,
  clientPanUniqueCheckSuccess: null,
  message: null,
  error: null,
  success: null,
  clientStatusSuccess: null,
  statusCode: null,
  clientDirectoryList: [],
  singleClientDirectory: {} as GetSingleClientDirectoryDetailsType,
  totalCount: null,
  leadDirectoryList: [],
  singleClientleadDirectoryDetails: [],
  leadDirectoryTotal: 0,
  leadDirectoryCommentsList: [],
  leadDirectoryCommentsFetching: false,
  leadDirectoryCommentsSuccess: null,
  leadDirectoryRecordingsList: [],
  leadDirectoryRecordingsFetching: false,
  leadDirectoryRecordingsSuccess: null,
  leadHistory: [],
  leadStageCount: [],
  leadFetching: false,
  emailFetching: false,
  leadClientEmailHistory: [],
  persistLeadDirectoryList: {
    data: [],
    offset: 0,
    scrollLeft: undefined,
    scrollTop: undefined,
    searchData: "",
  },
  clientMeetUpChecklistData: [] ,
  singleClientMeetUpChecklistData: {} as SingleClientMeetUpCheckListType ,
  uniqueCityList:[],
  uniqueCityCount:0,
  cityFetching:false,
  leadStageList:[],
  leadStageTotal:0
};
